import { createSlice } from "@reduxjs/toolkit";

const initial = {
  value: JSON.parse(localStorage.getItem("frejun-app")) ?? "Business phone",
};
localStorage.setItem("frejun-app", JSON.stringify(initial.value));

export const appSlice = createSlice({
  name: "app",
  initialState: initial,
  reducers: {
    setApp: (state, action) => {
      state.value = action.payload;
      localStorage.setItem("frejun-app", JSON.stringify(state.value));
    },
    resetAppState: (state) => {
      state.value = "Business phone";
    },
  },
});

export const { setApp, resetAppState } = appSlice.actions;
export default appSlice.reducer;
